<template>
  <div>
    <template v-if="project">
      <div class="grid md:grid-cols-2 gap-7 pt-8 md:pt-0 h-screen px-8">
        <div class="flex flex-col content-center justify-center h-full lg:max-w-lg pt-10 md:pt-0">
          <div class="max-w-xl text-center md:text-left mb-6">
            <img class="mx-auto my-2 md:mx-0 rounded-full w-20 h-20 object-cover shadow shadow-md" :src="project.icon" :alt="project.name"/>

            <h2 class="max-w-lg mb-6 font-sans text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl sm:leading-none">
              {{project.name}}
            </h2>
            <p class="text-base text-gray-700 md:text-lg">
              {{project.description}}
            </p>
          </div>
          <div class="md:mx-0 mx-auto">
            <Playstore :link="$route.params.id"/>
          </div>
        </div>
        <div class="flex flex-col content-start md:content-center md:justify-center md:h-full ">
          <div class="flex flex-wrap">
            <img class="mx-auto w-full md:w-4/5 transform rotate-6 transition hover:scale-105 duration-700 ease-in-out hover:-rotate-6" style="transform: scale(1) perspective(1040px) rotateY(-30deg) rotateX(2deg) rotate(2deg);" :src="project.banner" />
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="state === STATE.loading">
      <div class="h-screen grid">
         <span class="inline items-center justify-center inline-flex w-full">
          <svg class="animate-spin h-8 w-8 text-indigo-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <span class="animate-pulse text-lg font-bold ml-2">Loading...</span>
        </span>
      </div>

    </template>
    <template v-else-if="state === STATE.error">
      <div class="h-screen grid">
         <span class="inline items-center justify-center inline-flex w-full">
          <span class="animate-pulse text-lg font-bold ml-2">{{ error }} data not Found</span>
        </span>
      </div>
    </template>

  </div>
</template>

<script>
import { useRoute } from 'vue-router'
import Playstore from "@/components/Playstore";
import {projectById} from "@/firebase";
import {useSwrCache, STATE} from "@/composables/swr-cache";
export default {
  name: "ProjectDetail",
  components: {Playstore},
  setup() {
    const route = useRoute()

    const {
      data: project,
      error,
      state,
    } = useSwrCache(`${route.params.id}`, projectById);

    return {
      STATE,
      error,
      state,
      project,
    };
  }
}
</script>